<template>
  <v-dialog
    v-model="show"
    max-width="60vw"
    scrollable
    @click:outside="cancel"
  >
    <v-card
      flat
      class="pa-3 mt-2"
    >
      <v-card-title class="justify-center text-h5">
        {{ label }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          class="multi-col-validation mt-4"
        >
          <v-row>
            <v-col cols="12">
              <p class="text--secondary mb-0">
                Гость набирает блюда-триггеры и получает право на подарок. Подарок — из
                «Подарочного товара»: бесплатные позиции кассы, их заводит синхронизация.
                Подарок по умолчанию кладётся сам, гость меняет его или отказывается.
              </p>
            </v-col>

            <v-col
              cols="12"
              md="8"
            >
              <v-text-field
                v-model="name"
                :rules="[rules.required]"
                :error="hasError('name')"
                :error-messages="messages('name')"
                label="Название правила"
                hint="Видно только в админке — по нему правило ищут в списке"
                persistent-hint
                dense
                outlined
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-switch
                v-model="isEnabled"
                label="Правило включено"
                dense
                class="mt-1"
              ></v-switch>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <date-picker
                v-model="startsAt"
                label="Действует с"
                :rules="[rules.required]"
              ></date-picker>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <date-picker
                v-model="endsAt"
                label="Действует по (пусто — бессрочно)"
              ></date-picker>
            </v-col>

            <v-col cols="12">
              <v-divider class="mb-2"></v-divider>
              <span class="text-subtitle-2">За что даётся подарок</span>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="triggerKind"
                :items="triggerKinds"
                item-text="text"
                item-value="value"
                label="Условие"
                dense
                outlined
              ></v-select>
            </v-col>

            <v-col
              v-if="triggerKind === 'MenuCategory'"
              cols="12"
              md="6"
            >
              <v-autocomplete
                :value="triggerCategoryRkId"
                :items="categoryOptions"
                :rules="[rules.required]"
                :error="hasError('triggerCategoryRkId')"
                :error-messages="messages('triggerCategoryRkId')"
                item-text="name"
                item-value="rkId"
                label="Категория меню"
                hint="Новые блюда категории попадают в правило сами"
                persistent-hint
                dense
                outlined
                clearable
                @change="pickCategory"
              ></v-autocomplete>
            </v-col>

            <v-col
              v-if="triggerKind === 'Dishes'"
              cols="12"
              md="6"
            >
              <v-autocomplete
                v-model="triggerDishRkIds"
                :items="dishOptions"
                :rules="[rules.required]"
                :error="hasError('triggerDishRkIds')"
                :error-messages="messages('triggerDishRkIds')"
                item-value="rkId"
                :item-text="dishText"
                label="Блюда-триггеры"
                multiple
                chips
                small-chips
                deletable-chips
                dense
                outlined
              >
                <template #item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.category }} · {{ item.price }} сом</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="triggerQuantity"
                :rules="[rules.required]"
                :error="hasError('triggerQuantity')"
                :error-messages="messages('triggerQuantity')"
                type="number"
                min="1"
                label="Нужно блюд"
                dense
                outlined
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="giftQuantity"
                :rules="[rules.required]"
                :error="hasError('giftQuantity')"
                :error-messages="messages('giftQuantity')"
                type="number"
                min="1"
                label="Подарков"
                dense
                outlined
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-select
                v-model="orderType"
                :items="orderTypes"
                item-text="text"
                item-value="value"
                label="Тип заказа"
                hint="Пусто — любой"
                persistent-hint
                dense
                outlined
                clearable
              ></v-select>
            </v-col>

            <v-col cols="12">
              <v-switch
                v-model="isCumulative"
                label="Кратно: четыре блюда — два подарка"
                dense
                class="mt-0"
              ></v-switch>
            </v-col>

            <v-col cols="12">
              <v-divider class="mb-2"></v-divider>
              <span class="text-subtitle-2">Что дарим</span>
            </v-col>

            <v-col cols="12">
              <v-alert
                v-if="!giftOptions.length"
                type="info"
                text
                dense
              >
                Подарочного товара пока нет: выберите категории в «Настройки системы →
                Синхронизация меню» и нажмите «Синхронизировать с кассой» в «Подарочном товаре».
              </v-alert>
              <v-autocomplete
                v-model="giftDishRkIds"
                :items="giftItems"
                :rules="[rules.required]"
                :error="hasError('giftDishRkIds')"
                :error-messages="messages('giftDishRkIds')"
                item-value="rkId"
                :item-text="dishText"
                label="Подарки"
                hint="Из «Подарочного товара» — гость выбирает из этого списка"
                persistent-hint
                multiple
                chips
                small-chips
                deletable-chips
                dense
                outlined
              >
                <template #item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.category }} · {{ item.price }} сом</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
                <template #selection="{ item }">
                  <v-chip
                    small
                    close
                    :color="item.stale ? 'error' : undefined"
                    :outlined="item.stale"
                    @click:close="removeGift(item.rkId)"
                  >
                    {{ item.name }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="defaultGiftDishRkId"
                :items="chosenGiftOptions"
                :error="hasError('defaultGiftDishRkId')"
                :error-messages="messages('defaultGiftDishRkId')"
                item-value="rkId"
                :item-text="dishText"
                label="Подарок по умолчанию"
                hint="Его сервер кладёт сам: старое приложение подарков не знает, а в корзине гость заменит его на другой. Пусто — первый из списка."
                persistent-hint
                clearable
                dense
                outlined
              ></v-select>
            </v-col>

            <v-col cols="12">
              <v-divider class="mb-2"></v-divider>
              <span class="text-subtitle-2">Название для гостя</span>
            </v-col>

            <v-col cols="12">
              <translation-fields
                v-model="translations"
                :fields="translatedFields"
              />
            </v-col>

            <v-col
              v-if="resolution"
              cols="12"
            >
              <v-alert
                :type="resolution.missingDishRkIds.length ? 'warning' : 'info'"
                text
                dense
              >
                В актуальном меню найдено: блюд-триггеров — {{ resolution.triggerDishes }},
                подарочных — {{ resolution.giftDishes }}.
                <span v-if="resolution.missingDishRkIds.length">
                  Не найдены номера: {{ resolution.missingDishRkIds.join(', ') }} — блюда
                  нет в актуальном меню, а подарка — среди доступного подарочного товара.
                </span>
              </v-alert>
            </v-col>

            <v-col cols="12">
              <v-btn
                color="primary"
                class="me-3 mt-4"
                @click="saveData"
              >
                Сохранить
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                class="mt-4"
                type="reset"
                @click="cancel"
              >
                Отмена
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import DatePicker from '@/components/date-picker'
import TranslationFields from '@/components/translation-fields'
import { rules } from '@/helpers/validation'
import { hasErrorsForProperty, errorMessages } from '@/helpers'

export default {
  name: 'GiftRuleForm',
  components: { DatePicker, TranslationFields },
  props: ['save', 'show', 'cancellation', 'label'],
  data: () => ({
    rules,
    translatedFields: [
      { key: 'name', label: 'Название подарка для гостя', required: true },
    ],
    triggerKinds: [
      { value: 'MenuCategory', text: 'Категория меню' },
      { value: 'Dishes', text: 'Список блюд' },
      { value: 'PresentProviders', text: 'Блюда с признаком «даёт подарок»' },
    ],
    orderTypes: [
      { value: 'Delivery', text: 'Доставка' },
      { value: 'TakeAway', text: 'Самовывоз' },
    ],
  }),
  computed: {
    ...mapFormHandlers('giftRule/form', [
      'name',
      'isEnabled',
      'startsAt',
      'endsAt',
      'triggerKind',
      'triggerCategoryRkId',
      'triggerCategoryPath',
      'triggerCategoryDeliveryGuid',
      'triggerQuantity',
      'giftQuantity',
      'isCumulative',
      'orderType',
      'triggerDishRkIds',
      'giftDishRkIds',
      'defaultGiftDishRkId',
      'translations',
    ]),
    ...mapState('giftRule/form', [
      'dishOptions',
      'categoryOptions',
      'resolution',
      'errors',
      'giftOptions',
    ]),

    giftItems() {
      const known = new Set(this.giftOptions.map(x => x.rkId))
      const stale = this.giftDishRkIds
        .filter(rkId => !known.has(rkId))
        .map(rkId => {
          const dish = this.dishOptions.find(x => x.rkId === rkId)

          return {
            rkId,
            name: dish ? dish.name : `№ ${rkId}`,
            category: 'не подарочный товар — уберите',
            price: dish ? dish.price : 0,
            stale: true,
          }
        })

      return [...this.giftOptions, ...stale]
    },

    chosenGiftOptions() {
      return this.giftOptions.filter(dish => this.giftDishRkIds.includes(dish.rkId))
    },
  },
  watch: {
    show(value) {
      if (value && this.$refs.form) this.$refs.form.resetValidation()
    },
  },
  methods: {
    ...mapActions('giftRule/form', ['resetForm']),

    removeGift(rkId) {
      this.giftDishRkIds = this.giftDishRkIds.filter(x => x !== rkId)
    },

    dishText(dish) {
      return `${dish.name} · ${dish.category} · ${dish.price} сом`
    },

    pickCategory(rkId) {
      const category = this.categoryOptions.find(x => x.rkId === rkId)

      this.triggerCategoryRkId = rkId ?? null
      this.triggerCategoryPath = category?.path ?? null
      this.triggerCategoryDeliveryGuid = category?.deliveryGuid ?? null
    },
    hasError(property) {
      return hasErrorsForProperty(this.errors, property)
    },
    messages(property) {
      return errorMessages(this.errors, property)
    },
    cancel() {
      this.resetForm()
      this.cancellation()
    },
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.save()
        this.resetForm()
      }
    },
  },
}
</script>
